// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fontArial{
    font-family: Arial, Helvetica, sans-serif;
}
.f10px{
    font-size: 10px !important;
}
.f12px{
    font-size: 12px !important;
}
.f14px{
    font-size: 14px !important;
}
.f16px{
    font-size: 16px;
}
.f18px{
    font-size: 18px;
}

.fw700{
    font-weight: 700;
}

.fontItalic {
    font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/Assets/css/font.css"],"names":[],"mappings":"AAAA;IACI,yCAAyC;AAC7C;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".fontArial{\n    font-family: Arial, Helvetica, sans-serif;\n}\n.f10px{\n    font-size: 10px !important;\n}\n.f12px{\n    font-size: 12px !important;\n}\n.f14px{\n    font-size: 14px !important;\n}\n.f16px{\n    font-size: 16px;\n}\n.f18px{\n    font-size: 18px;\n}\n\n.fw700{\n    font-weight: 700;\n}\n\n.fontItalic {\n    font-style: italic;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
